import { render, staticRenderFns } from "./SetDocumentControlDlg.vue?vue&type=template&id=5615bfc5"
import script from "./SetDocumentControlDlg.vue?vue&type=script&lang=js"
export * from "./SetDocumentControlDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports